
import request from '../request'

//查询
export function queryPlanEditorList() {
    return request({
        url: '/plan/queryBdthPlanList',
        method: 'get',
        data: {}
    })
}

//删除
export function deletePlanEditor(id) {
    return request({
        url: '/plan/deletePlan?id='+id,
        method: 'get',
        data: {}
    })
}


//保存
export function createPlanEditor(data){
    return request({
        url: '/plan/createPlan',
        method: 'post',
        data: data
    })
}

//修改
export function updatePlanEditor(data){
    return request({
        url: '/plan/createPlan',
        method: 'post',
        data: data
    })
}

export function queryBdthPlanById(id){
    
    return request({
        url: '/plan/queryBdthPlanById?id='+id,
        method: 'get',
        data: {}
    })
}

export function copyBdthPlanById(id){
    
    return request({
        url: '/plan/copyBdthPlanById?id='+id,
        method: 'get',
        data: {}
    })
}